import type { RiskStatusMessageKey } from '../logic/riskScorePresentation';

export const RISK_ENGINE_BUNDLE = 'features.risk-engine.translations.riskEngine';

export type RiskEngineMessageKey =
  | RiskStatusMessageKey
  | 'pageTitle'
  | 'pageDescription'
  | 'timeWindow'
  | 'timeWindowSevenDays'
  | 'timeWindowFourteenDays'
  | 'timeWindowThirtyDays'
  | 'timeWindowNinetyDays'
  | 'filtersButton'
  | 'filterFlyoutTitle'
  | 'filterApply'
  | 'filterClearAll'
  | 'filterTimeWindowClear'
  | 'filterTimeWindowListTitle'
  | 'filterLocationTitle'
  | 'filterLocationClear'
  | 'filterLocationListTitle'
  | 'filterCategoryTitle'
  | 'filterCategoryClear'
  | 'filterCategoryListTitle'
  | 'filterMetricTitle'
  | 'filterMetricClear'
  | 'filterMetricListTitle'
  | 'filterStatusTitle'
  | 'filterStatusClear'
  | 'filterStatusListTitle'
  | 'filterOptionWithCount'
  | 'scoredDate'
  | 'exportButton'
  | 'exportInProgress'
  | 'exportError'
  | 'exportEmpty'
  | 'breakdownExportEmpty'
  | 'tableLabel'
  | 'columnLocation'
  | 'columnMetricCategory'
  | 'columnMetric'
  | 'columnRiskStatus'
  | 'columnActual'
  | 'columnTarget'
  | 'columnGapToTarget'
  | 'loading'
  | 'loadError'
  | 'noBusinessUnitData'
  | 'noLocationData'
  | 'noFilterResults'
  | 'missingLocations'
  | 'drilldownExpand'
  | 'drilldownCaption'
  | 'driverBarLabel'
  | 'driverContribution'
  | 'drilldownLoading'
  | 'drilldownError'
  | 'drilldownRetry'
  | 'drilldownEmpty'
  | 'breakdownTitle'
  | 'breakdownQuestion'
  | 'breakdownTargetLabel'
  | 'breakdownGapLabel'
  | 'breakdownDriversTitle'
  | 'breakdownDriversCaption'
  | 'nodePercentOfTarget'
  | 'columnImpact'
  | 'expandRow';
